/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderStlRoutingModule } from './builder-stl-routing.module';
import { StlListComponent } from './components/stl-list/stl-list.component';
import { StlBusinessService } from './resources/stl-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderStlRoutingModule,
  ],
  providers: [
    StlBusinessService,
  ],
  declarations: [
    StlListComponent,
  ],
})

export class BuilderStlModule {
}
